import React from 'react';
import './../css/App.css';
import AppRouter from './components/AppRouter';
import { createTheme, ThemeProvider } from '@mui/material/styles';
const outerTheme = createTheme({
  palette: {
    primary: {
      main: '#118924',
    },
  },
});

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={outerTheme}>
        <AppRouter />
      </ThemeProvider>
    </div>
  );
}

export default App;
